import { CopyrightText } from '@/components/copyright-text'

interface MainAppLayoutProps {
  children: React.ReactNode
}

export const MainAppLayout = (props: MainAppLayoutProps): JSX.Element => {
  return (
    <main className="flex min-h-screen flex-col bg-[#F5F7FC]">
      <div className="flex grow flex-col">{props.children}</div>
      <footer className="mt-auto py-3">
        <p className="text-center text-xs text-[#C4C6CB]">
          <CopyrightText />
        </p>
      </footer>
    </main>
  )
}

export function getMainAppLayout(page: React.ReactElement): JSX.Element {
  return <MainAppLayout>{page}</MainAppLayout>
}
